export const isValidHttpUrl = (url?: string | null): boolean => {
  if (!url) return false;
  return url.startsWith('http://') || url.startsWith('https://');
};

export const hasSupportedAudioExtension = (url?: string | null): boolean => {
  if (!url) return false;
  const cleanUrl = url.split('?')[0].split('#')[0];
  const lastDot = cleanUrl.lastIndexOf('.');
  if (lastDot === -1) return false;
  const ext = cleanUrl.slice(lastDot + 1).toLowerCase();
  return ['wav', 'mp3', 'ogg'].includes(ext);
};

export const validateBackgroundAudioUrl = (
  url?: string | null
): string | false => {
  if (!url) return 'URL is required';
  if (!isValidHttpUrl(url)) {
    return 'URL must start with http:// or https://';
  }
  if (!hasSupportedAudioExtension(url)) {
    return 'URL must end with .wav, .mp3, or .ogg';
  }
  return false;
};
